export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5405.51d62c8e.jpg";